import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { PrivyProvider } from '@privy-io/react-auth';
import { WagmiProvider } from '@privy-io/wagmi';
import { Toaster } from 'sonner';
import { config } from './lib/wagmi';
import { AdminAuthProvider } from './contexts/AdminAuthContext';
import App from './App';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000,
      refetchOnWindowFocus: false,
    },
  },
});

// Same Privy App ID as main app
const PRIVY_APP_ID = 'cmi6sw8zk00b3ie0ccqk2pq8q';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <PrivyProvider
        appId={PRIVY_APP_ID}
        config={{
          loginMethods: ['wallet'],
          appearance: {
            theme: 'dark',
            accentColor: '#10b981',
          },
          embeddedWallets: {
            ethereum: {
              createOnLogin: 'off',
            },
          },
        }}
      >
        <WagmiProvider config={config}>
          <AdminAuthProvider>
            <App />
            <Toaster
              position="top-right"
              toastOptions={{
                style: {
                  background: '#000',
                  color: '#fff',
                  border: '1px solid rgba(255,255,255,0.1)',
                  fontFamily: 'JetBrains Mono, monospace',
                  fontSize: '12px',
                },
              }}
            />
          </AdminAuthProvider>
        </WagmiProvider>
      </PrivyProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
